var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "scoket-container"
  }, [_c("div", {
    staticClass: "chat-container"
  }, [_c("div", {
    staticClass: "status"
  }, [_vm._v(" " + _vm._s(_vm.socketStatus) + " ")]), _c("scroll-bar", {
    ref: "scrollBar",
    staticStyle: {
      width: "100%",
      height: "400px",
      padding: "6px 0 15px"
    }
  }, [_c("p", {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.newsList[_vm.newsList.length - 1].date))]), _vm._l(_vm.newsList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "list-item",
      class: {
        "text-right": index % 2 === 0
      }
    }, [index % 2 == 0 ? _c("div", {
      staticClass: "message myself"
    }, [_vm._v(_vm._s(item.message))]) : _vm._e(), _c("a-avatar", {
      attrs: {
        src: item.imgUrl,
        size: 35
      }
    }), index % 2 != 0 ? _c("div", {
      staticClass: "message",
      domProps: {
        innerHTML: _vm._s(item.message)
      }
    }) : _vm._e()], 1);
  })], 2)], 1), _c("a-comment", [_c("a-avatar", {
    attrs: {
      slot: "avatar",
      src: _vm.imgUrl,
      alt: "Han Solo"
    },
    slot: "avatar"
  }), _c("div", {
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, [_c("a-form-item", [_c("a-textarea", {
    attrs: {
      rows: 3,
      value: _vm.textValue
    },
    on: {
      change: _vm.changeText
    }
  })], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      "html-type": "submit",
      type: "primary"
    },
    on: {
      click: _vm.sendNews
    }
  }, [_vm._v(" 发送 ")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };